define('TescoMobile_Catalog/js/view/return-cart',['jquery', 'Magento_Ui/js/modal/modal', 'Magento_Customer/js/customer-data', 'TescoMobile_Catalog/js/action/return-cart-ajax-reload'], function ($, modal, customerData, returnCartAjaxReload) {
  'use strict';

  return function (config, el) {
    var widget = widget || {};
    widget.returnCart = {
      init: function (el) {
        var _self = this;
        this.showModal(el);
      },
      openModal: function (el) {
        var options = {
          type: 'popup',
          innerScroll: true,
          modalClass: "welcome-modal small-popup",
          buttons: ''
        };
        var html = $(el),
          popup = modal(options, html);
        html.modal('openModal');
      },
      showModal: function (el) {
        var deferred = $.Deferred(),
          _self = this;
        returnCartAjaxReload(deferred);
        $.when(deferred).done(function (response) {
          if (response.success) {
            _self.openModal(el);
            customerData.invalidate(['cart', 'checkout-data']);
          }
          return true;
        }).fail(function (response) {
          console.log(response);
        });
      }
    };
    widget.returnCart.init(el);
  };
});

